// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"868":"57c059a466180cac","1980":"31ba1c36f43dc877","3274":"5a453488e50a2e2c","4896":"84f6640a228a67d3","5259":"fc301960a33d88b1","8199":"f01407468f07465e"}[chunkId] + ".css";
};